export default __webpack_public_path__ + "static/media/b_teamwork_large.1d5fba18.png";